import Modal from '../../../../components/Modal';
import PropTypes from 'prop-types';

const AudioModal = ({ isOpen, onClose, audioUrl }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} titleName="Audio" contentWidth="50%">
      <div className="resource-view d-flex justify-content-center">
        <audio controls>
          <source src={audioUrl} type="audio/mpeg" />
        </audio>
      </div>
    </Modal>
  );
};
  
AudioModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  audioUrl: PropTypes.string
};

export default AudioModal;